<template>
    <div
        class="relative desktop:min-h-[60vh] largeDesktop:min-h-[50vh] py-3 px-2.5 rounded-[10px] border-[1px] border-[#CCCCCC] bg-white bg-opacity-50">
        <div
            class="mobile:w-[90%] mobile:right-0 mobile:left-0 desktop:w-1/3 laptop:w-4/5 largeDesktop:w-2/6 mx-auto flex tablet:justify-end  items-center gap-2 absolute -top-6 tablet:right-6 tablet:left-auto">
            <entities :modelValue="limit" @update:modelValue="onLimitChange" globalEntitiesClass="'tablet:w-[45%]'" />
        </div>

        <div v-if="grouped.bundles.length > 0" class="mb-4">
            <h6 class="mobile:mb-5 laptop:mb-3 font-roboto text-[16px] text-[#666666]">Bundles</h6>
            <div class="flex flex-col gap-2">
                <protectionBundleSearchCard v-for="(item, index) in grouped.bundles" :key="index" :item="item"
                    @click="planModalBundle(item)" />
            </div>
        </div>
        <div v-if="grouped.plans.length > 0" class="mb-4">
            <h6 class="mobile:mb-5 laptop:mb-3 font-roboto text-[16px] text-[#666666]">Protection Plans</h6>
            <div class="flex flex-col gap-2">
                <protectionPlanSearchCard v-for="(item, index) in grouped.plans" :key="index" :item="item"
                    @click="planModal(item)" />
            </div>
        </div>
        <div v-if="grouped.history.length > 0">
            <h6 class="mobile:mb-5 laptop:mb-3 font-roboto text-[16px] text-[#666666]">Protection Plans History</h6>
            <div class="flex flex-col gap-2">
                <protectionPlanHistoryCard v-for="(item, index) in grouped.history" :key="index" :item="item"
                    @click="itemClicked(item)" />
            </div>
        </div>
        <div class="desktop:min-h-[60vh] largeDesktop:min-h-[50vh]"
            v-if="!grouped.history.length && !grouped.plans.length && !grouped.bundles.length">
            <h6 class="text-center m-0 text-gray-400">
                No Record Found
            </h6>
        </div>
        <div
            class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative top-8">
            <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
                :totalItems="totalItems" />
            <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
        </div>
    </div>

    <!-- Protection Plan History Modal -->
    <div class="modal fade" id="protectionPlanHistoryCard" ref="protectionPlanHistoryCard" tabindex="-1"
        aria-labelledby="protectionPlanHistoryCard" aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content select-none">
                <div class="modal-body !p-3 !pb-5">
                    <div
                        class="relative w-full mobile:h-[70px] tablet:h-[100px] rounded-lg overflow-hidden flex items-center justify-start">
                        <button type="button"
                            class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
                        </button>
                        <div class="relative w-full h-full flex flex-col items-center justify-center">
                            <img src="../../assets/images/profile-bg.png"
                                class="w-full object-contain absolute left-0 top-0" alt="backgroundImage">
                            <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12">
                                <h6 class="m-0 text-xl font-roboto font-semibold text-black-100">
                                    Details
                                </h6>
                                <img :src="planDetails && planDetails.partner_company_logo" alt="contractor Logo"
                                    class="w-14 h-14 object-contain">
                            </div>
                        </div>
                    </div>
                    <div
                        class="responsiveOreitationHeightAdjust mobile:max-h-[90vh] desktop:max-h-[70vh] largeDesktop:max-h-[90vh] overflow-y-auto customScrollbar mobile:mt-2 tablet:mt-4">
                        <companyDetailDropdown :item="planDetails" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Protection Plan Detail Modal -->
    <div class="modal fade" id="protectionPlanDetailModal" ref="protectionPlanDetailModal" tabindex="-1"
        aria-labelledby="protectionPlanDetailModal" aria-hidden="true" data-bs-backdrop="static"
        data-bs-keyboard="false">
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content select-none">
                <div class="modal-body !p-3 !pb-5" v-if="protectionPlanDetails">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-4 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                            <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
                        </button>
                        <div class="relative rounded-lg overflow-hidden h-[100px]">
                            <img src="../../assets/images/profile-bg.png" alt="Background"
                                class="w-full mobile:h-full tablet:h-auto object-cover">
                            <div class="flex flex-col justify-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                                <div class="flex justify-start items-center gap-1">
                                    <div class="w-1.5 h-1.5 rounded-full bg-purple-100"></div>
                                    <div class="w-6 h-1.5 rounded-full bg-purple-100"></div>
                                    <p class=" text-lg font-bold font-roboto pl-2 m-0 text-fuchsia-700">New Plan</p>
                                </div>
                                <h4 class="mobile:text-lg table:text-xl m-0 text-black-100">{{
                                    protectionPlanDetails.plan_name }}</h4>
                            </div>
                        </div>
                    </div>
                    <div
                        class="responsiveOreitationHeightAdjust mobile:max-h-[50vh] mobile:mt-8 tablet:mt-5 tablet:max-h-[70vh] desktop:max-h-[50vh] largeDesktop:max-h-[70vh] pr-2 mb-3 overflow-y-auto customScrollbar">
                        <protectionPlanDetailCard :plan="protectionPlanDetails" />
                    </div>
                    <div class="py-3">
                        <span v-if="protectionPlanDetails.quantity == null || protectionPlanDetails.quantity == 0"
                            @click="updateCounter('increment')"
                            class="w-max group px-3 py-1.5 flex justify-center items-center mx-auto gap-1 text-base rounded-full cursor-pointer border-[1px] !border-secondary-100 text-secondary-100 hover:bg-secondary-100 hover:text-white">
                            <img src="../../assets/images/cart-check.png"
                                class="w-7 h-7 object-contain group-hover:hidden" alt="icon">
                            <img src="../../assets/images/cart-check-white.png"
                                class="w-7 h-7 object-contain !hidden group-hover:!block" alt="icon">
                            Select this plan
                        </span>
                        <div v-else class="flex w-full justify-center items-center gap-4">
                            <quantityCounter v-if="protectionPlanDetails.is_show_quantity == 1"
                                :quantity="protectionPlanDetails.quantity" @update-counter="updateCounter" />
                            <button v-else type="button" @click="updateCounter('remove')"
                                class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#F67280] hover:bg-[#F67280]">
                                <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                                    class="w-7 h-7 group-hover:hidden">
                                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                                    class="w-7 h-7 hidden group-hover:!block">
                            </button>
                            <span type="button"
                                class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 bg-secondary-100 text-white">
                                <img src="../../assets/images/cart-check-white.png" alt="Cart Icon" class="w-7 h-7">
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Bundle Detail Modal -->
    <bundleDetailModal ref="protectionCarDetailtRef" @event="updateCart" :isCartUpdate="isCartUpdate" />
</template>


<script>
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import protectionPlanSearchCard from '../../components/globalSearch/protectionPlanSearchCard.vue';
import protectionBundleSearchCard from '../../components/globalSearch/protectionBundleSearchCard.vue';
import protectionPlanHistoryCard from '../../components/globalSearch/protectionPlanHistoryCard.vue';
import companyDetailDropdown from "../../components/companyDetailModal.vue"
import protectionPlanDetailCard from '../../components/protectionPlansCards/protectionPlanDetailCard.vue';
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import quantityCounter from '../../components/partialComponent/quantityCounter.vue';
import entities from "../../components/showEntities/entities.vue";
import bundleDetailModal from "../../components/protectionPlansCards/bundleDetailModal.vue";


export default {
    data() {
        return {
            limit: 5,
            page: 1,
            total_pages: 0,
            planDetails: null,
            loading: false,
            totalItems: 0,
            isOpenFromCart: false,
            isCartUpdate: false,
            plans: [],
            cartCount: {},
            updateCard: null,
            updateCardCart: null,
            searchList: [],
            selectedType: 'plan',
            selectedPlan: {},
        };
    },
    components: {
        protectionBundleSearchCard,
        protectionPlanSearchCard,
        protectionPlanHistoryCard,
        companyDetailDropdown,
        protectionPlanDetailCard,
        customPagination,
        paginationEntries,
        quantityCounter,
        entities,
        bundleDetailModal
    },
    computed: {
        ...mapGetters(["searchResults",
            "salesPlanDetails",
            "protectionPlanDetails",
            "cartUpdated",
            "cartValidate",
            "removeProtectionCartData",
        ]),

        grouped() {
            const plans = [];
            const history = [];
            const bundles = [];
            if (this.searchList) {
                this.searchList.forEach(item => {
                    if (item.record_type == 'plans') {
                        plans.push(item);
                    } else if (item.record_type == 'history') {
                        history.push(item);
                    }
                    else if (item.record_type == 'bundles') {
                        bundles.push(item);
                    }
                });
            }

            return { plans, history, bundles };
        }
    },
    watch: {

        removeProtectionCartData: function (data) {

            if (this.selectedType == 'bundle') {
                this.upsertCart({
                    "bundle_id": this.selectedPlan.id,
                    "quantity": this.selectedPlan.quantity,
                    "partner_id" : this.planDetails.partner_id
                })
            }
            else {
                this.upsertCart({
                    "plan_id": this.selectedPlan.id,
                    "quantity": this.selectedPlan.quantity,
                    "partner_id" : this.planDetails.partner_id
                })
            }

        },
        cartValidate: function (data) {

            if (this.cartValidate.validation_passed) {

                if (this.selectedType == 'bundle') {
                    this.upsertCart({
                        "bundle_id": this.selectedPlan.id,
                        "quantity": this.selectedPlan.quantity,
                        "partner_id" : this.planDetails.partner_id
                    })
                }
                else {
                    this.upsertCart({
                        "plan_id": this.selectedPlan.id,
                        "quantity": this.selectedPlan.quantity,
                        "partner_id" : this.planDetails.partner_id
                    })
                }

            }
            else {

                this.$confirmDialog.show({
                    title: "Action Required",
                    message: this.cartValidate.message,

                    onConfirm: () => {
                        this.removeBundle(this.cartValidate)
                    },
                });
            }

        },

        '$route.query': {
            immediate: true,
            handler(newQuery) {
                if (this.$helper.isEmpty(this.$route.query.q)) {
                    this.page = 1
                    this.total_pages = 0
                    this.totalItems = 0
                    this.searchList = []
                } else {
                    if (!this.$helper.isEmpty(this.$route.query.q)) {
                        this.page = 1
                        this.getSearchResults({
                            search: this.$route.query.q,
                            page: this.page,
                            limit: this.limit
                        })
                    }
                }
            },
        },

        cartUpdated: function (data) {
            this.getCartCount({
                is_hide: true
            });
        },

        searchResults: function (data) {
            this.loading = false
            this.searchList = this.searchResults.body
            this.total_pages = this.searchResults.paging.total_pages
            this.totalItems = this.searchResults.paging.total_records
        },
        salesPlanDetails: function (data) {
            this.planDetails = this.salesPlanDetails
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.protectionPlanHistoryCard;
            this.Modal = Modal.getInstance(modalEl);
            if (!this.Modal) {
                this.Modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
                this.adjustModalHeightprotectionPlanHistory();
            });
            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
                window.removeEventListener('resize', this.adjustModalHeightprotectionPlanHistory);
                window.removeEventListener('orientationchange', this.adjustModalHeightprotectionPlanHistory);
            });
            window.addEventListener('resize', this.adjustModalHeightprotectionPlanHistory);
            window.addEventListener('orientationchange', this.adjustModalHeightprotectionPlanHistory);
            this.Modal.show();
        },

        protectionPlanDetails: function (data) {
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.protectionPlanDetailModal;

            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
                this.adjustModalHeightprotectionPlanDetail();
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
                window.removeEventListener('resize', this.adjustModalHeightprotectionPlanDetail);
                window.removeEventListener('orientationchange', this.adjustModalHeightprotectionPlanDetail);
            });

            // Add orientation/resize responsiveness
            window.addEventListener('resize', this.adjustModalHeightprotectionPlanDetail);
            window.addEventListener('orientationchange', this.adjustModalHeightprotectionPlanDetail);
            this.modal.show();
            this.$refs.protectionPlanDetailModal.addEventListener('hidden.bs.modal', this.onCartModalClose);
        },

    },
    mounted() {
        document.body.style.overflow = 'hidden';
    },
    beforeUnmount() {
        document.body.style.overflow = '';
    },
    methods: {
        ...mapActions([
            "getSearchResults",
            "getSalesPlanDetails",
            "getProtectionPlanDetails",
            "upsertCart",
            "getCartCount",
            "validateCart",
            "removeProtectionItemCart"
        ]),

        removeBundle(data) {
            this.removeProtectionItemCart({
                "bundle_ids": data.bundle_ids,
                "plan_ids": data.plan_ids,
            })
        },
        adjustModalHeightprotectionPlanDetail() {
            const modalContent = this.$refs.protectionPlanDetailModal?.querySelector('.responsiveOreitationHeightAdjust');
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 400) {
                    // Mobile devices
                    maxHeight = vh * 0.8 - 40; // 90% of viewport height minus some padding
                } else if (vw < 768) {
                    // Mobile devices
                    maxHeight = vh * 0.7 - 40; // 90% of viewport height minus some padding
                } else if (vw < 1024) {
                    // Tablets
                    maxHeight = vh * 0.4 - 30;
                } else {
                    // Desktops
                    maxHeight = vh * 0.7 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },
        adjustModalHeightprotectionPlanHistory() {
            const modalContent = this.$refs.protectionPlanHistoryCard?.querySelector('.responsiveOreitationHeightAdjust');
            if (modalContent) {
                const vh = window.innerHeight;
                const vw = window.innerWidth;
                let maxHeight;
                if (vw < 400) {
                    // Mobile devices
                    maxHeight = vh * 0.8 - 40; // 90% of viewport height minus some padding
                } else if (vw < 768) {
                    // Mobile devices
                    maxHeight = vh * 0.9 - 40; // 90% of viewport height minus some padding
                } else if (vw < 1024) {
                    // Tablets
                    maxHeight = vh * 0.6 - 30;
                } else {
                    // Desktops
                    maxHeight = vh * 0.8 - 40;
                }
                modalContent.style.maxHeight = `${maxHeight}px`;
                modalContent.style.overflowY = 'auto';
            }
        },
        itemClicked(data) {
            this.getSalesPlanDetails({
                id: data.id
            })
        },
        planModal(plan) {
            this.getProtectionPlanDetails({
                id: plan.id
            })
        },

        planModalBundle(plan) {
            // this.getProtectionPlanDetails({
            //     id: plan.id
            // })

            this.$refs.protectionCarDetailtRef.openCartModal(plan)

        },

        updatePage(page) {
            if (page == this.page && !this.$helper.isEmpty(this.$route.query.q)) return
            this.page = page
            this.loading = true
            this.getSearchResults({
                "search": this.$route.query.q,
                "limit": this.limit,
                "page": this.page
            });
        },

        updateCounter(option) {
            if (option == "increment") {
                this.protectionPlanDetails.quantity++
            } else if (option == "decrement") {
                if (this.protectionPlanDetails.quantity > 1) {
                    this.protectionPlanDetails.quantity--
                } else {
                    this.protectionPlanDetails.quantity = 0
                }
            } else {
                this.protectionPlanDetails.quantity = 0
            }
            this.updateCart(option, {
                id: this.protectionPlanDetails.id,
                quantity: this.protectionPlanDetails.quantity,
                type: 'plan'
            })
        },

        updateCart(option, plan, type = 'plan' ,action, details) {

            this.planDetails = details
            this.selectedPlan = plan
            this.selectedType = type

            if (option == "cartUpdate") {
                this.isCartUpdate = true
            } else {
                this.isCartUpdate = false
            }

            if (option == 'decrement' || option == 'remove') {

                if (type == 'bundle') {
                    this.upsertCart({
                        "bundle_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id" : details.partner_id
                    })
                }
                else {
                    this.upsertCart({
                        "plan_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id" : details.partner_id
                    })
                }

            }
            else {

                if (type == 'bundle') {
                    this.validateCart({
                        "bundle_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id" : details.partner_id
                    })
                }
                else {
                    this.validateCart({
                        "plan_id": plan.id,
                        "quantity": plan.quantity,
                        "partner_id" : details.partner_id
                    })
                }
            }

        },
        onLimitChange(newLimit) {
            this.limit = newLimit;
            if (!this.$helper.isEmpty(this.$route.query.q)) {
                this.page = 1;
                this.loading = true;
                this.getSearchResults({
                    search: this.$route.query.q,
                    limit: this.limit,
                    page: this.page,
                });
            }
        }
    }
}
</script>